<template>
  <div>
<!--    <commingSoon />-->
    <b-container>
      <b-card class="mt-4 pb-0">
        <h2 class="text-center text-primary font-size-20 font-weight-bold position-relative main-header mb-5">
          {{$t('endUser.privacyPolicy')}}</h2>
        <p class="text-justify font-size-20 text-black px-4">
          منصة إبل هي منصة متخصصة بتقديم كافة الخدمات المتعلقة بالإبل في المملكة العربية السعودية، وتشمل خدمات التأمين والنقل والتصريح، ومتاجر الأعلاف وأعذية ومستلزمات الإبل وخدمات البيطرة، كما تعتبر منصة تداول الإبل الرئيسية من بيع وشراء وتأجير ومشاركة منصة إبل هي منصة متخصصة بتقديم كافة الخدمات المتعلقة بالإبل في المملكة العربية السعودية، وتشمل خدمات التأمين والنقل والتصريح، ومتاجر الأعلاف وأعذية ومستلزمات الإبل وخدمات البيطرة، كما تعتبر منصة تداول الإبل الرئيسية من بيع وشراء وتأجير ومشاركة منصة إبل هي منصة متخصصة بتقديم كافة الخدمات المتعلقة بالإبل في المملكة العربية السعودية، وتشمل خدمات التأمين والنقل والتصريح، ومتاجر الأعلاف وأعذية ومستلزمات الإبل وخدمات البيطرة، كما تعتبر منصة تداول الإبل الرئيسية من بيع وشراء وتأجير ومشاركة منصة إبل هي منصة متخصصة بتقديم كافة الخدمات المتعلقة بالإبل في المملكة العربية السعودية، وتشمل خدمات التأمين والنقل والتصريح، ومتاجر الأعلاف وأعذية ومستلزمات ،منصة إبل هي منصة متخصصة بتقديم كافة الخدمات المتعلقة بالإبل في المملكة العربية السعودية، وتشمل خدمات التأمين والنقل والتصريح، ومتاجر الأعلاف وأعذية ومستلزمات الإبل وخدمات البيطرة، كما تعتبر منصة تداول الإبل الرئيسية من بيع وشراء وتأجير ومشاركةالإبل وخدمات البيطرة، كما تعتبر منصة تداول الإبل الرئيسية من بيع وشراء وتأجير ومشاركة
        </p>
      </b-card>
    </b-container>
  </div>
</template>
<script>
import { core } from '@/config/pluginInit'
export default {
  name: 'privacyPolicy',
  mounted () {
    core.index()
  },
  data () {
    return {
    }
  }
}
</script>
